export default __webpack_public_path__ + "static/media/Yenepoya Photos-2.8baf17ee.png";